import React, {Component} from 'react';
import './CustomerSalesItemTableRow.css';
import {RESOURCE_BASE_URL} from "../../../../configuration";
import axios from "axios";
import {FormattedMessage} from "react-intl";
import ItemDetailsModal from "../../../Site/Order/OrderHistory/OrderItem/ItemDetailsModal";
import ViewItemDetails from "../ViewSingleCustomerSale/ViewItemDetails/ViewSalesItemDetails";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import InitialQuotationState from "../../../Site/QuotationForm/InitialQuotationState";

const ImageView = (props) => {
    if (props.imagePath) {
        return <img className="cart-item-preview-image" alt="" src={props.imagePath}/>
    } else {
        return <span>X</span>
    }
};
class CustomerSalesItemTableRow extends Component {

    constructor(props) {
        super(props);
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
            show: false,
            pdfData : {},
            pdf : {},
            productBarcode:''

        };
        this.getPdfData = this.getPdfData.bind(this);
        this.getProductionBarcodeBYOrderId = this.getProductionBarcodeBYOrderId.bind(this);

    }

    getPdfData = () => {

        let orderResourceUrl = RESOURCE_BASE_URL + 'api/barcode/generate/'+this.props.orderInfo.id+'/'+InitialQuotationState.lang;
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };
        let postData = {

            barcode : this.props.orderInfo.barcode != null ? this.props.orderInfo.barcode : "0000-00000000"

        };

        axios.post(orderResourceUrl, postData, axiosConfig)
            .then((res) => {

                fetch("data:application/pdf;base64," + res.data.pdfFile)
                    .then((resp)=> {return resp.blob()})
                    .then((blob) => {
                        // console.log("BLOB====> ",blob);

                        const fileURL = URL.createObjectURL(blob);
                        window.open(fileURL);
                        // window.location.href = fileURL;

                    });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    getProductionBarcodeBYOrderId = () => {

        axios.get(RESOURCE_BASE_URL + 'api/production/order/' + this.props.itemInfo.id + '/' + this.props.orderId)
            .then((res) => {
                this.setState({
                    productBarcode: res.data.productBarcode,

                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    componentDidMount() {
        this.getProductionBarcodeBYOrderId();
    }

    render() {

        // console.log("ORDER ITEM INFO DUO ===> ",this.props.itemInfo);
        //
        // let pcbParams = JSON.parse(this.props.itemInfo.quotation.pcbParamJson);
        // let priceInfo = JSON.parse(this.props.orderInfo.chargeDetails.priceInfoJson);
        // let dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
        //     pcbParams.width+"*"+pcbParams.length+"" : '';
        return (
            <div>
                <div className="row admin-single-order-item-row-margin">
                    <div className="col-md-2 custom-col-2 resp-vertical-align">
                        <span>{this.props.itemInfo.barcode}</span></div>
                    <div className="col-md-2 custom-col-2 no-padding resp-vertical-align">
                        <ImageView imagePath={this.props.itemInfo.imageUrlFrontEncoded}/>
                    </div>
                    <div className="col-md-2 custom-col-2 resp-vertical-align">
                        {/*<span>{this.props.itemInfo.itemName}</span>*/}


                        {this.state.productBarcode!==null && this.state.productBarcode!=='' ?
                            <span>{this.state.productBarcode.substring(1,13)}</span>:
                            <span>-</span>
                        }

                    </div>
                    <div className="col-md-1 custom-col-1 resp-vertical-align">
                        <span>
                            {/*{this.props.orderInfo.quantity}*/}
                            {this.props.itemInfo.quotation.orderType===1 &&
                             <text>{this.props.itemInfo.quotation.pcbParam.qty}</text>
                            }
                            {this.props.itemInfo.quotation.orderType===3 &&
                            <text>{this.props.itemInfo.quotation.stencilParam.stencilQty}</text>
                            }
                            {this.props.itemInfo.quotation.orderType===2 &&
                            <text>{this.props.itemInfo.quotation.pcbParam.qty}</text>
                            }

                        </span></div>
                    <div className="col-md-2 custom-col-2 resp-vertical-align">
                        <span className=" admin-order-view-table-cost">
                            {/*{this.props.orderInfo.unitPrice}*/}
                            <NumberFormatter num = {this.props.itemInfo.unitPrice}/>
                        </span>
                    </div>
                    <div className="col-md-1 custom-col-1 resp-vertical-align">
                        <span className="pull-right admin-order-view-table-cost">
                            {this.props.itemInfo.quotation.orderType===1 ?
                                    <text>PCB</text>:
                                this.props.itemInfo.quotation.orderType===3?
                                    <text>SMT</text>:<text>{this.props.itemInfo.quotation.orderType}</text>
                            }

                        </span>
                    </div>
                    <div className="col-md-2 custom-col-2 resp-vertical-align">
                        <div className="row center-align">
                            {/*<button className="btn btn-xs btn-primary">
                                <FormattedMessage id="app.admin.single.order.View"
                                                  defaultMessage="View.
                                                  description=""/>
                            </button>*/}
                            <ViewItemDetails orderType={this.props.itemInfo.quotation.orderType}
                                              pcbParams={this.props.itemInfo.quotation.pcbParams}
                                              itemDetails={this.props.itemInfo}
                            />&nbsp;
                            {/*<button className="glyphicon glyphicon-open">
                            </button>*/}
                            {/*<a href="#" className="btn btn-success btn-xs" onClick={this.getPdfData}>
                                <FormattedMessage id="app.admin.single.order.stock-chart"
                                                  defaultMessage="Stock Chart"
                                                  description=""/></a>*/}

                        </div>
                    </div>
                    <br/>
                </div>
            </div>
        )
    }
}
export default CustomerSalesItemTableRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CustomerSalesItemTableRow/CustomerSalesItemTableRow.js